"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _axios = _interopRequireDefault(require("axios"));

var _config = _interopRequireDefault(require("../../../../config.json"));

var _errorPage = _interopRequireDefault(require("../../../error-views/errorPage"));

// import { useHistory } from 'react-router';
var Option = _antd.Select.Option;

var TableData = function TableData(_ref) {
  var onCancel = _ref.onCancel,
      item = _ref.item,
      showEdit = _ref.showEdit;
  // const history = useHistory();
  var cl = localStorage.getItem("CL");
  var token = localStorage.getItem("token"); // eslint-disable-next-line 

  var _useState = (0, _react.useState)(showEdit),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      apiError = _useState4[0],
      setapiError = _useState4[1];

  var _Form$useForm = _antd.Form.useForm(),
      _Form$useForm2 = (0, _slicedToArray2.default)(_Form$useForm, 1),
      form = _Form$useForm2[0]; // useEffect(async () => {
  //     console.log(item);
  //     let initialFormValues = {
  //         token: item.Token_no,
  //         doj: item.Joining_date.substring(0, 10),
  //         name: item.Student_name,
  //         code: item.RM_code,
  //         class: item.Class,
  //         status: item.Parent_status,
  //         subject: item.Subject,
  //         contact: item.Calling_no,
  //         whatsaAppNUm: item.WhatsApp_no,
  //         address: item.Address
  //     }
  //     form.setFieldsValue(initialFormValues);
  // }, [item]);


  (0, _react.useEffect)(function () {
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }

    function _fetchData() {
      _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var initialFormValues;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(item);
                initialFormValues = {
                  token: item.Token_no,
                  doj: item.Joining_date.substring(0, 10),
                  name: item.Student_name,
                  code: item.RM_code,
                  class: item.Class,
                  status: item.Parent_status,
                  subject: item.Subject,
                  contact: item.Calling_no,
                  whatsaAppNUm: item.WhatsApp_no,
                  address: item.Address
                };
                form.setFieldsValue(initialFormValues);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchData.apply(this, arguments);
    }

    fetchData(); // eslint-disable-next-line 
  }, [item]);

  var handleOk = function handleOk() {
    var f1 = form.getFieldsValue();
    var obj = {
      name: f1.name,
      class: f1.class,
      status: f1.status,
      rmcode: f1.code,
      subject: f1.subject,
      address: f1.address,
      calling: f1.contact,
      whatsapp: f1.whatsaAppNUm
    };
    var url = _config.default.updateStudent + cl + "&token=" + item.Token_no;

    _axios.default.post(url, obj, {
      headers: {
        'Authorization': token
      }
    }).then(function (resp) {
      if (resp.data.status === "error") setapiError(resp.data); // else{

      alert("Updated Successfully");
      window.location = '/clPortal/app/parent/allparent';
      onCancel(); //}
    }, function (err) {
      var obj = {
        "status": "error",
        "message": "Network Error"
      };
      if (err.response) setapiError(err.response);else setapiError(obj);
    });
  };

  return apiError ? /*#__PURE__*/_react.default.createElement(_errorPage.default, {
    details: apiError
  }) : /*#__PURE__*/_react.default.createElement(_antd.Modal, {
    title: "Edit Student Information",
    visible: visible,
    onOk: handleOk,
    onCancel: onCancel,
    cancelButtonProps: {
      hidden: true
    },
    okText: "Save"
  }, /*#__PURE__*/_react.default.createElement(_antd.Form, {
    form: form,
    layout: "vertical",
    name: "new-event",
    preserve: false
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: "16"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 12
  }, /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "name",
    label: "Name"
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    autoComplete: "off"
  }))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 12
  }, /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "code",
    label: "RM Code"
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    autoComplete: "off"
  })))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: "16"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 12
  }, /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "token",
    label: "Token No"
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    autoComplete: "off",
    disabled: true
  }))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 12
  }, /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "status",
    label: "Status"
  }, /*#__PURE__*/_react.default.createElement(_antd.Select, null, /*#__PURE__*/_react.default.createElement(Option, {
    value: "Enrolled"
  }, "Enrolled"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "Drop Out"
  }, "Drop Out"))))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: "16"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 12
  }, /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "class",
    label: "Class"
  }, /*#__PURE__*/_react.default.createElement(_antd.Select, null, /*#__PURE__*/_react.default.createElement(Option, {
    value: "1st"
  }, "1st"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "2nd"
  }, "2nd"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "3rd"
  }, "3rd"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "4th"
  }, "4th"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "5th"
  }, "5th"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "AWC"
  }, "AWC"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "LKG"
  }, "LKG"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "No Class"
  }, "No Class"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "Nursery"
  }, "Nursery"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "Play"
  }, "Play"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "UkG"
  }, "UKG")))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 12
  }, /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    label: "Subject",
    name: "subject"
  }, /*#__PURE__*/_react.default.createElement(_antd.Select, null, /*#__PURE__*/_react.default.createElement(Option, {
    value: "Math"
  }, "Math"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "English"
  }, "English"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "Both"
  }, "Both"))))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: "16"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 12
  }, /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "contact",
    label: "Contact Number",
    rules: [{
      required: true,
      message: 'Please Enter Valid Number!'
    }, function () {
      return {
        validator: function validator(_, value) {
          var pattern = new RegExp(/^[0-9\b]+$/);

          if (pattern.test(value) && value.length === 10) {
            return Promise.resolve();
          }

          return Promise.reject(new Error('Please Check the Phone Number!'));
        }
      };
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    className: "w-100"
  }))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 12
  }, /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "whatsaAppNUm",
    label: "WhatsApp Number",
    rules: [{
      required: true,
      message: 'Please Enter Valid Number!'
    }, function () {
      return {
        validator: function validator(_, value) {
          var pattern = new RegExp(/^[0-9\b]+$/);

          if (pattern.test(value) && value.length === 10) {
            return Promise.resolve();
          }

          return Promise.reject(new Error('Please Check the Phone Number!'));
        }
      };
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    className: "w-100"
  })))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: "16"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 12
  }, /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "doj",
    label: "Date of Joining"
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    className: "w-100",
    disabled: true
  }))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 12
  }, /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "address",
    label: "Address"
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    className: "w-100"
  }))))));
};

var _default = TableData;
exports.default = _default;